// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3boTg","file":"styles_file__1xpUv"};